import pkg from 'async';
const { queue } = pkg;
function tick(task, cb) {
    let isCallbacked = false;
    const done = (err, res) => {
        if (isCallbacked) {
            return;
        }
        isCallbacked = true;
        if (task.done) {
            setImmediate(task.done, err, res);
        }
        setImmediate(cb);
    };
    let args = [done];
    if (task.args) {
        args = args.concat(task.args);
    }
    try {
        task.worker.apply(task.worker, args);
    }
    catch (e) {
        done(e.toString());
    }
}
export class Sequence /*implements ISequence*/ {
    constructor(config) {
        this.counter = 1;
        this.name = config.name;
        this.queue = queue(tick, 1);
    }
    add(worker, args, cb) {
        let done;
        if (!cb && args && typeof args === 'function') {
            done = args;
        }
        else {
            done = cb;
        }
        if (worker && typeof worker === 'function') {
            const task = { worker, done };
            if (Array.isArray(args)) {
                task.args = args;
            }
            task.counter = this.counter++;
            this.queue.push(task);
        }
    }
    count() {
        return this.queue.length();
    }
}
//# sourceMappingURL=sequence.js.map